/* @flow */
import dynamic from 'next/dynamic';
import getConfig from 'next/config';

import React from 'react';
import { connect } from 'react-redux';
import styled from 'styled-components';
// $FlowFixMe
import { Button } from '@bijie/react-bnb';

import FlexBox from '../FlexBox';
import { commonEmails, getEmailName } from '../../utils/email';
import withI18n from '../../utils/withI18n';
import { getLabel } from '../../utils/i18n';

import Help from './Help';
import CountDown from '../CountDown';

const GeeTest = dynamic(import('../../network/GeeTest'), {
  ssr: false,
  loading: () => null,
});

const {
  publicRuntimeConfig: {
    assetPrefix,
  },
} = getConfig();

const EmailVerifyBox = styled(FlexBox)`
  width: 100%;
`;

const Content = styled.div`
  max-width: 470px;
  background: #fff;
  padding: 40px;
`;

const DescBox = styled.div`
  width: 100%;
  text-align: center;
  > h3 {
    font-size:24px;
    font-weight:500;
    color:rgba(33,40,51,1);
    line-height:32px;
  }
  > p {
    font-size:14px;
    font-family: ${({ theme }) => theme.fontIBMRegular};
    color:rgba(33,40,51,1);
    line-height:20px;
  }
`;

const Line = styled.div`
  width: 100%;
  height: 1px;
  background: rgba(234,236,239,1);
  margin: 30px 0 30px;
`;

const StyledLink = styled.a`
  display: block;
  margin: 30px 0;
  .bnc-btn {width: 100%;}
`;
const EmailResend = styled.a`
  display:inline-block;
  font-size: 14px;
  font-weight: 400;
  color: ${({ sending, theme }) => (sending ? 'rgba(132, 142, 156, 1)' : theme.highlight)};
  line-height: 17px;
  margin-top: 20px;
  cursor: ${({ sending }) => (sending ? 'not-allowed' : 'pointer')};
  > span {
    margin-right: 4px;
  }
  &:hover {
    border-bottom: 1px solid #f0b90b;
    color: #f0b90b;
  }
`;


type Props = {
  i18n: Object,
  locale: string,
  email: string,
  title: string,
  desc: string,
  sending: boolean,
  resendEmail: any,
  onCountDownEnd: Function,
  cutDownTime: number,
};

type CaptType = {
  getValidate: Function,
  verify: Function,
}

 type State = {
  capt: CaptType,
};

const mapStateToProps = ({ locale }) => ({ locale });

export default
@withI18n
@connect(mapStateToProps)
class EmailVerify extends React.Component<Props, State> {
 static defaultProps = {
   i18n: {},
   locale: 'en',
   email: '',
   title: '',
   desc: '',
   sending: false,
   resendEmail: false,
   onCountDownEnd: () => {},
   cutDownTime: 600,
 }

 state = {
   capt: {
     getValidate: (): Object => ({}),
     verify: () => { },
   },
 }

 _handleGeetestReady = (capt: CaptType) => {
   this.setState({
     capt,
   });
 };

_handleGeetestError = () => {};

_handlerGeetestSuccess = async () => {
  const { capt } = this.state;
  // eslint-disabled-next-line
  const {
    geetest_challenge: geetestChallenge,
    geetest_seccode: geetestSecCode,
    geetest_validate: geetestValidate,
  } = capt.getValidate();
  this.props.resendEmail({
    geetestChallenge, geetestSecCode, geetestValidate, validateCodeType: 'gt',
  });
};

_handleGeetestClose = () => {};

_handleCountDownEnd = () => {};

_resendEmail = () => {
  if (!this.props.sending) this.state.capt.verify();
}

render() {
  const {
    i18n, locale, email, title, desc, sending, resendEmail, onCountDownEnd, cutDownTime,
  } = this.props;
  let emailLink = '';
  if (email) {
    const emailName = getEmailName(email);
    emailLink = emailName ? commonEmails[emailName] : '';
  }
  const lang = locale === 'cn' ? 'zh-cn' : 'en';
  return (
    <EmailVerifyBox justify="center" className="email-verify">
      <Content>
        <FlexBox justify="center" margin="0 0 30px 0">
          <img width="104" height="104" src={assetPrefix + require('./email_verification.svg')} alt="email" />
        </FlexBox>
        <DescBox>
          <h3>{title}</h3>
          {/* eslint-disable-next-line */}
          <p dangerouslySetInnerHTML={{ __html: desc }} />
        </DescBox>
        {emailLink ? (
          <StyledLink href={emailLink} target="_blank">
            <Button type="primary" block={true} size="lg">
              {getLabel('exchange-register-goToEmailVerify', i18n)}
            </Button>
          </StyledLink>) : <Line />}
        <Help i18n={i18n} locale={locale} />
        {resendEmail && (
        <EmailResend onClick={this._resendEmail} sending={sending} align="center">
          <span>{getLabel('exchange-register-resendEmail', i18n)}</span>
          {sending && <CountDown seconds={cutDownTime} onCountDownEnd={onCountDownEnd} />}
        </EmailResend>)}
      </Content>
      <GeeTest
        success={1}
        product="bind"
        lang={lang}
        onReady={this._handleGeetestReady}
        onError={this._handleGeetestError}
        onSuccess={this._handlerGeetestSuccess}
        onClose={this._handleGeetestClose}
      />
    </EmailVerifyBox>
  );
}
}
